import React, { useState } from "react";
import { Col, Image, Row } from "antd";
import LoginImg from "../../assests/login-landing-image.png";
import "./LoginPage.css";
import { useMediaQuery } from "react-responsive";
import CreateNewPassword from "./createnewpassword/CreateNewPassword";
import ForgotPassword from "./forgotpassword/ForgotPassword";
import LoginFields from "./loginfields/LoginFields";
import AMPlogo from "../../assests/ampg-svg.svg";
import AMPlogo_w from "../../assests/ampw-svg.svg";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  localStorage.removeItem("token");
  const isSmL = useMediaQuery({ maxWidth: 767 });
  const navigate = useNavigate();
  const [currentComponent, setCurrentComponent] = useState("login");
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // Function to render the appropriate component
  const renderComponent = () => {
    switch (currentComponent) {
      case "login":
        return <LoginFields navigateTo={setCurrentComponent} />;
      case "forgotPassword":
        return <ForgotPassword navigateTo={setCurrentComponent} />;
      case "reset-password":
        return <CreateNewPassword navigateTo={setCurrentComponent} />;
      default:
        return <LoginFields navigateTo={setCurrentComponent} />;
    }
  };

  return (
    <div className="login-container">
      <Row style={{ height: "100%" }}>
        {!isMobile ? (
          <Col span={12}>
            <div
              className="login-image"
              style={{
                backgroundImage: `url(${LoginImg})`,
                height: "100%",
                width: "100%",
              }}
            >
              <div className="gradient-layer" />
              <Image
                preview={false}
                src={AMPlogo_w}
                alt="Logo"
                className="logo-overlay"
                onClick={() => navigate("/")}
              />
            </div>
          </Col>
        ) : null}
        <Col xs={24} sm={24} md={12} className="login-form-container">
          {isSmL ? (
            <div className="common-css">
              <Image
                src={AMPlogo}
                alt="amp-logo"
                height={60}
                width={190}
                preview={false}
                onClick={() => navigate("/")}
              />
            </div>
          ) : null}

          {/* Render the selected component */}
          {renderComponent()}
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
